import { render, staticRenderFns } from "./BelowInfoPanel.vue?vue&type=template&id=0fe53322"
import script from "./BelowInfoPanel.vue?vue&type=script&lang=js"
export * from "./BelowInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports